import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { LawTab, MSDSTab, AccidentTab } from "./tabs";
import { tabStyles, tabPanelStyles } from "./tabs/styles";

interface EvidenceReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EvidenceReviewModal: React.FC<EvidenceReviewModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay />
      <ModalContent
        bg="white"
        borderRadius="12px"
        maxH="80vh"
        h="600px"
        display="flex"
        flexDirection="column"
      >
        <ModalHeader pb={2} flexShrink={0}>
          <VStack align="start" spacing={1}>
            <Text fontSize="24px" fontWeight="700" color="#1A202C">
              {t("evidenceReview.title")}
            </Text>
            <Text fontSize="16px" color="#6B7280">
              {t("evidenceReview.subtitle")}
            </Text>
          </VStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          pb={6}
          flex="1"
          overflow="hidden"
          display="flex"
          flexDirection="column"
        >
          <Tabs
            variant="unstyled"
            colorScheme="blue"
            display="flex"
            flexDirection="column"
            h="100%"
          >
            <TabList
              bg="#005EB826"
              borderRadius="12px"
              p={1}
              display="flex"
              gap={1}
              flexShrink={0}
            >
              <Tab {...tabStyles}>{t("evidenceReview.tabs.law")}</Tab>
              <Tab {...tabStyles}>{t("evidenceReview.tabs.msds")}</Tab>
              <Tab {...tabStyles}>{t("evidenceReview.tabs.accident")}</Tab>
            </TabList>

            <TabPanels flex="1" overflow="hidden">
              <TabPanel {...tabPanelStyles}>
                <LawTab />
              </TabPanel>
              <TabPanel {...tabPanelStyles}>
                <MSDSTab />
              </TabPanel>
              <TabPanel {...tabPanelStyles}>
                <AccidentTab />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EvidenceReviewModal;
